import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import PATHS, { mergePaths } from 'utils/paths';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import AddModuleModal from '../Modules/AddModuleModal';
import AddPackageModal from './AddPackageModal';

const Packages = () => {
	const { pathname } = useLocation();
	const isPackage = useMemo(() => pathname === mergePaths(PATHS.PACKAGES, PATHS.PACKAGES_LIST), [pathname]);
	const tabs = useMemo(
		() => [
			{
				label: 'packages',
				path: mergePaths(PATHS.PACKAGES, PATHS.PACKAGES_LIST)
			},
			{
				label: 'modules',
				path: mergePaths(PATHS.PACKAGES, PATHS.MODULES)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="packages"
				lordIcon={
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/boxes-icon.json.gz'
				}>
				<Authorization path={`/modal/add-${isPackage ? 'package' : 'module'}-modal`}>
					<Button
						icon={faPlus}
						label={isPackage ? 'addPackage' : 'addModule'}
						onClick={() => NiceModal.show(isPackage ? AddPackageModal : AddModuleModal)}
					/>
				</Authorization>
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default Packages;
